export default "/images/vendor/flag-icons/flags/1x1/bo.svg?b233abbddb9060df2dbf3b830958f763";